function beforeAddToCart(callback) {
  var styleCustomizeIdArray = [];
  var style = selectedStyleData;
  console.log("selectedstyle", style);
  if (style) {
    if (style.currentVariantID !== undefined && style.price > 0) {
      styleCustomizeIdArray.push({
        id: style.currentVariantID,
        name: style.name,
      });
    }
    style.components.forEach(function (el) {
      if (
        el.currentVariantID !== null &&
        el.currentVariantID !== 0 &&
        Array.isArray(el.currentVariantID)
      ) {
        if (Array.isArray(el.currentVariantID)) {
          el.currentVariantID.forEach(function (val, key) {
            if (el.price[key] !== null && el.price[key] > 0) {
              styleCustomizeIdArray.push({
                id: el.currentVariantID[key],
                name: el.newValue[key],
              });
            }
          });
        } else {
          styleCustomizeIdArray.push({
            id: el.currentVariantID,
            name: el.newValue ? el.newValue : el.baseValue,
          });
        }
      } else if (!Array.isArray(el.currentVariantID)) {
        if (
          el.currentVariantID !== null &&
          el.currentVariantID !== 0 &&
          el.price !== null &&
          (el.price > 0 || Array.isArray(el.price)) &&
          el.newValue 
        ) {
          if (Array.isArray(el.currentVariantID)) {
            el.currentVariantID.forEach(function (id, index) {
              var newValue = null;

              if (Array.isArray(el.price) && el.price[index] === 0) {
                return;
              }

              if (el.newValue && Array.isArray(el.newValue)) {
                newValue = el.newValue[index];
              } else {
                newValue = el.newValue;
              }

              styleCustomizeIdArray.push({
                id: id,
                name: newValue,
              });
            });
          } else {
            styleCustomizeIdArray.push({
              id: el.currentVariantID,
              name: el.newValue ? el.newValue : el.baseValue,
            });
          }
        }
      }
    });
    productsQueue(styleCustomizeIdArray, function (status, id) {
      callback(status, id);
    });
    console.log(styleCustomizeIdArray);
  } else {
    callback(true);
  }
}
function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}
function unitID() {
  var min = 1,
    max = new Date().getTime();
  return getRandomInt(min, max) + new Date().getTime();
}
function getProductVariantID() {
  if (window.productVariantId !== undefined) {
    return window.productVariantId;
  } else if (productSetting.products.variants.length) {
    return productSetting.products.variants[0].id;
  } else {
    return productSetting.products.id;
  }
}
function getProductVariantTitle() {
  if (window.productVariantTitle !== undefined) {
    return window.productVariantTitle;
  } else if (productSetting.products.variants.length) {
    return productSetting.products.variants[0].name;
  } else {
    return productSetting.products.title;
  }
}
function productsQueue(array, callback) {
  var parentId = null;
  Shopify.queue = [];
  /* Shopify.queue.push({
        variantId: getProductVariantID(),
        name: getProductVariantTitle(),
        index: -1
    }); */
  array.forEach(function (el, i) {
    var product = el;
    Shopify.queue.push({
      variantId: product.id,
      name: product.name,
      index: i,
    });
  });
  parentId = unitID();
  var id = parentId,
    productProperties = {
      productId: id,
    },
    componentProperties = {
      parentId: id,
    };
  var propFields = $("#product-form")
    .find('input[name*="properties"]')
    .toArray();

  propFields.forEach(function (field) {
    var name = $(field)
        .attr("name")
        .match(/(\[.*\])/)[0]
        .replace("[", "")
        .replace("]", ""),
      value = $(field).attr("value");
    productProperties[name] = value;
  });
  ajaxProductAdd(productProperties, componentProperties, callback, parentId);
}
function ajaxProductAdd(
  productProperties,
  componentProperties,
  callback,
  parentId
) {
  // If we still have requests in the queue, let's process the next one.
  if (Shopify.queue.length) {
    var request = Shopify.queue.shift(),
      data =
        request.index === -1
          ? {
              quantity: 1,
              id: request.variantId,
              properties: productProperties,
            }
          : {
              quantity: 1,
              id: request.variantId,
              properties: componentProperties,
            };

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: data,
      success: function success(res) {
        ajaxProductAdd(
          productProperties,
          componentProperties,
          callback,
          parentId
        );
      },
      error: function error(err) {
        callback(false);
        // if happen error with order of main product we show error and stop the cycle
        if (request.index === -1) {
          $("#cart-error-message").html(
            err.responseJSON ? err.responseJSON.description : ""
          );
          $("#initiateCartModal").click();
          alertifyjs__WEBPACK_IMPORTED_MODULE_9___default()
            .alert(
              "Luxire Warning",
              "Happen error with you order - ".concat(
                err.responseJSON.description
              )
            )
            .set("onok", function () {
              window.location.reload();
            });
        } else {
          // if it's not last one Move Along else update the cart number with the current quantity
          if (Shopify.queue.length) {
            ajaxProductAdd(productProperties, componentProperties);
          } else {
            window.location.href = "/cart";
          }
        }
      },
    });
  } // If the queue is empty, we add 1 to cart
  else {
    //window.location.href = '/cart';
    callback(true, parentId);
  }
}
